module.exports = __webpack_public_path__ + "ebac89cc7076b22f84904bf08cdc5813.png";